<template>
    <div class="ievp-score">
        <div class="ievp-score-graph-container">
            <div
                class="ievp-score-graph"
                v-for="(score, index) in mappedScores"
                :key="`score_${index}`"
                :class="{ personal: score.personal, organization: !score.personal }"
            >
                <div class="ievp-score-graph-label">{{ score.label }}</div>
                <div :style="`left: ${score.left}%`" class="ievp-score-graph-marker" v-tooltip="score.tooltip" />
            </div>

            <div class="ievp-score-graph-container-label">{{ $t('reportsWeb.LEAST_IMPORTANT') }}</div>
            <div class="ievp-score-graph-container-label">{{ $t('reportsWeb.MOST_IMPORTANT') }}</div>
        </div>
    </div>
</template>
<script lang="ts" src="./IevpScore.ts"></script>
<style lang="scss">
@import '@/variables';

$ievp-score-marker-height: 1.5rem;
$ievp-score-marker-width: 0.5rem;
$ievp-score-label-width: 8rem;

$ievp-colors: (
    'personal': #ffb967,
    'organization': #0f84d3,
);

.ievp-score {
    &-graph-container {
        position: relative;
        margin: 1rem 0 2rem;
        padding-bottom: 1rem;
        padding-left: $ievp-score-label-width;

        &-label {
            position: absolute;
            bottom: 0;
            font-size: 0.875rem;
            color: $dark-color;
            width: 25%;

            &:first-child {
                left: 0;
            }

            &:last-child {
                right: 0;
                text-align: right;
            }
        }
    }

    &-graph {
        position: relative;
        height: calc($ievp-score-marker-height * 1.25);
        margin-bottom: 1rem;

        &::before {
            display: block;
            position: absolute;
            border-radius: $border-radius;
            top: calc($ievp-score-marker-height / 2);
            height: 4px;
            width: 100%;
            content: '';
        }

        @each $key, $color in $ievp-colors {
            &.#{$key} {
                &::before {
                    background: rgba($color, 0.6);
                }

                .ievp-score-graph-marker {
                    border: 1px $color solid;
                    background: $color;
                }
            }
        }

        &-marker {
            height: $ievp-score-marker-height;
            width: $ievp-score-marker-width;
            border-radius: $border-radius;
            background: $dark-gray;
            position: absolute;
            top: 2px;
        }

        &-label {
            position: absolute;
            left: -#{$ievp-score-label-width};
            top: 2px;
            font-weight: bold;
            width: $ievp-score-label-width;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-right: 0.5rem;
        }
    }
}
</style>
